export enum LuckyTicketStatus {
    All,
    Pending ,
    Active ,
    Done ,
    Cancelled
}
